// Age gate, derived from birthdate.
//
// Per CLAUDE.md: never store a stored `is_21_plus` flag — it drifts on
// birthdays. Always compute from the player's birthdate at check time.
//
// This file is the ONE SOURCE OF TRUTH for age math across the app so
// signup + wager gate + betting-calculator agree at day boundaries.
// The Netlify function helper (netlify/functions/_ageGate.js) re-exports
// from here + adds server-only conveniences.
//
// Currently used by:
//   - betting calculator (21+, via meetsAgeGate) — original caller
//   - signup floor (13+, D-352 / F-094-T1) via isUnderSignupAge
//   - wager under-18 gate (F-094-T1) via isUnder18 → net _ageGate.js

// ── UTC-anchored age math (F-094-T1) ─────────────────────────────────
// Signup + wager helpers use UTC parsing so client + server agree at
// day-boundary edges (a user on their birthday must not be blocked by
// one and allowed by the other because of the deploy-region tz). The
// birthdate string is "YYYY-MM-DD"; we anchor it at midnight UTC.
export function isUnderAge(birthdate, minAge) {
  if (!birthdate) return false
  const bd = new Date(birthdate + 'T00:00:00Z')
  if (Number.isNaN(bd.getTime())) return false
  const now = new Date()
  let age = now.getUTCFullYear() - bd.getUTCFullYear()
  const m = now.getUTCMonth() - bd.getUTCMonth()
  if (m < 0 || (m === 0 && now.getUTCDate() < bd.getUTCDate())) age -= 1
  return age < minAge
}

export function isUnder18(birthdate) {
  return isUnderAge(birthdate, 18)
}

export function isUnderSignupAge(birthdate) {
  return isUnderAge(birthdate, 13)
}

export const SIGNUP_MIN_AGE = 13
export const WAGER_MIN_AGE = 18

// ── Legacy local-time helper (unchanged) ─────────────────────────────
// meetsAgeGate is called only by golf.test.js today (21+ betting math).
// Kept on local Date parsing because its call sites and tests reason
// about the user's own timezone; migrating it to UTC would shift the
// existing tests without a bug to fix. New code should prefer isUnderAge
// (UTC) for anything shared with the server.
export function meetsAgeGate(birthdate, minAge) {
  if (!birthdate) return false
  const dob = new Date(birthdate)
  if (Number.isNaN(dob.getTime())) return false
  const now = new Date()
  let age = now.getFullYear() - dob.getFullYear()
  const m = now.getMonth() - dob.getMonth()
  if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) age--
  return age >= minAge
}
